var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-o enable-page-overlay sidebar-dark side-scroll page-header-fixed",attrs:{"id":"page-container"}},[_c('navigation'),_c('topbar'),_c('main',{attrs:{"id":"main-container"}},[_c('transition',{attrs:{"name":"fade"}},[(this.$store.state.loading)?_c('loader'):_vm._e()],1),_c('router-view')],1),_c('bottombar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }